const tableMap = [
  {
    type: "角色扮演",
    title: "灵异.雪豹模拟器",
    name: "良城",
    uin: '235801876',
    mapId: '5407599627540',
    img: "1-map"
  },
  {
    type: "养成",
    title: "瓜茸－兔美镇四周年",
    name: "子瓜茸",
    uin: '149314886',
    mapId: '43662786846022',
    img: "2-map"
  },
  {
    type: "闯关",
    title: "雪豹行动",
    name: "冷晨",
    uin: '339332387',
    mapId: '80488026459427',
    img: "3-map"
  },
  {
    type: "闯关",
    title: "雪豹历险记",
    name: "cxy",
    uin: '386864836',
    mapId: '49225007044292',
    img: "4-map"
  },
  {
    type: "角色扮演",
    title: "【茶语】+雪域守望",
    name: "柚茶",
    uin: '40619945',
    mapId: '75114723659689',
    img: "5-map"
  },
  {
    type: "对战",
    title: "锁爱-保护野生动物",
    name: "魂印",
    uin: '499372817',
    mapId: '2680558965521',
    img: "6-map"
  },
  {
    type: "塔防",
    title: "美食大战老鼠-保卫雪豹",
    name: "任易仙",
    uin: '59722992',
    mapId: '16222151199984',
    img: "7-map"
  },
  {
    type: "建筑",
    title: "动物博物馆",
    name: "建筑缔造者",
    uin: '257093154',
    mapId: '33509591936546',
    img: "8-map"
  },
  {
    type: "对战",
    title: "柒星-躲猫猫&雪域守望",
    name: "Set sail【夜喵】",
    uin: '252083294',
    mapId: '23180190579806',
    img: "9-map"
  },
  {
    type: "对战",
    title: "TYS-雪豹奇缘",
    name: "残阳",
    uin: '781610664',
    mapId: '77198523788968',
    img: "10-map"
  },
  {
    type: "闯关",
    title: "雪豹的眼泪",
    name: "噗嗤猪",
    uin: '308809295',
    mapId: '94223301348943',
    img: "11-map"
  }
];
const tableCreate = [
  {
    img: "781",
    name: "xxxxxxx1",
  },
  {
    img: "781",
    name: "xxxxxxx2",
  },
  {
    img: "781",
    name: "xxxxxxx3",
  },
  {
    img: "781",
    name: "xxxxxxx4",
  },
  {
    img: "781",
    name: "xxxxxxx5",
  },
  {
    img: "781",
    name: "xxxxxxx6",
  },
  {
    img: "781",
    name: "xxxxxxx7",
  },
  {
    img: "781",
    name: "xxxxxxx8",
  },
  {
    img: "781",
    name: "xxxxxxx9",
  },
];
const tableCartoon = [
  {
    name: "Oliver.J ",
    title: "349641552",
    img: "1-cartoon"
  },
  {
    name: "北方",
    title: "22695138",
    img: "2-cartoon"
  },
  {
    name: "方塘",
    title: "186885759",
    img: "3-cartoon"
  },
  {
    name: "老王",
    title: "10287815",
    img: "4-cartoon"
  },
  {
    name: "陌墨",
    title: "415913883 ",
    img: "5-cartoon"
  },
  {
    name: "桃心 ",
    title: "72884752 ",
    img: "6-cartoon"
  }
];
const tableVidio = [
  {
    title: "微电影《魔法校园》",
    name: "迷你世界小书生",
    img: "1-vidio",
    aUrl: "https://open.iqiyi.com/developer/player_js/coopPlayerIndex.html?vid=e5c8269e77070c30d31ceefcaca3932f&tvId=14268302500&accessToken=2.f22860a2479ad60d8da7697274de9346&appKey=3955c3425820435e86d0f4cdfe56f5e7&appId=1368&height=100%&width=100%"
  },
  {
    title: "雪豹国公主的故事",
    name: "迷糊酱莉莉",
    img: "2-vidio",
    aUrl: "https://open.iqiyi.com/developer/player_js/coopPlayerIndex.html?vid=04a5a2d9cc1a7ab63d26412087ac4de0&tvId=14311650200&accessToken=2.f22860a2479ad60d8da7697274de9346&appKey=3955c3425820435e86d0f4cdfe56f5e7&appId=1368&height=100%&width=100%"
  },
  {
    title: "动物让人类不孤单",
    name: "臻艺浮生柔风",
    img: "3-vidio",
    aUrl: "https://open.iqiyi.com/developer/player_js/coopPlayerIndex.html?vid=e5c8269e77070c30d31ceefcaca3932f&tvId=14268302500&accessToken=2.f22860a2479ad60d8da7697274de9346&appKey=3955c3425820435e86d0f4cdfe56f5e7&appId=1368&height=100%&width=100%"
  },
  {
    title: "送雪豹平安回家",
    name: "欣然游戏解说",
    img: "4-vidio",
    aUrl: "https://open.iqiyi.com/developer/player_js/coopPlayerIndex.html?vid=ce6ff2f4da08bdfa62ecf0a29c1d4fb9&tvId=14298600800&accessToken=2.f22860a2479ad60d8da7697274de9346&appKey=3955c3425820435e86d0f4cdfe56f5e7&appId=1368&height=100%&width=100%"
  },
  {
    title: "保护雪豹公益片",
    name: "青音、若兮",
    img: "5-vidio",
    aUrl: "https://open.iqiyi.com/developer/player_js/coopPlayerIndex.html?vid=88ea1596b56b03f5b61d73c95b69b07e&tvId=14330381100&accessToken=2.f22860a2479ad60d8da7697274de9346&appKey=3955c3425820435e86d0f4cdfe56f5e7&appId=1368&height=100%&width=100%"
  },
  {
    title: "关于一只雪豹的故事",
    name: "迷你世界",
    img: "6-vidio",
    aUrl: "https://open.iqiyi.com/developer/player_js/coopPlayerIndex.html?vid=a0586e20a10acc1a6318eb70ce7ac923&tvId=13953408400&accessToken=2.f22860a2479ad60d8da7697274de9346&appKey=3955c3425820435e86d0f4cdfe56f5e7&appId=1368&height=100%&width=100%"
  }
];
const snowArray = [{
  id: 1,
  itemName: '雪豹1',
  name: '命名着1',
  text: '哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒',
  imgShow: 'P-one',
  headerImg: require(`../assets/images/S1.png`),
  logo: '曾小糖gogo1',
  imgSelect: [
    {
      id: 1,
      blackText: '蒙层1111',
      img: require(`../assets/images/Q1.jpg`),
      type:'images'
    },
  ]
}, {
  id: 2,
  itemName: '雪豹2',
  name: '命名着2',
  text: '哇222真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒',
  imgShow: 'P-two',
  headerImg: require(`../assets/images/S2.png`),
  logo: '曾小糖gogo2',
  imgSelect: [
    {
      id: 1,
      blackText: '蒙层1111',
      img: require(`../assets/images/Q1.jpg`),
      type:'images'
    },
    {
      id: 2,
      blackText: '蒙层222222',
      img: require(`../assets/images/Q2.jpg`),
      video:'https://i.snssdk.com/videofe/xigua/detail?group_id=6804712560730833415',
      type:'video'
    }
  ]
}, {
  id: 3,
  itemName: '雪豹3',
  name: '命名着3',
  text: '哇3333真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒',
  imgShow: 'P-one',
  headerImg: require(`../assets/images/S3.png`),
  logo: '曾小糖gogo3',
  imgSelect: [
    {
      id: 1,
      blackText: '蒙层1111',
      img: require(`../assets/images/Q1.jpg`),
      type:'images'
    },
    {
      id: 2,
      blackText: '蒙层222222',
      img: require(`../assets/images/Q2.jpg`),
      video:'https://i.snssdk.com/videofe/xigua/detail?group_id=6804712560730833415',
      type:'video'
    },
    {
      id: 3,
      blackText: '蒙层33333',
      img: require(`../assets/images/Q3.jpg`),
      type:'images'
    }
  ]
}, {
  id: 4,
  itemName: '雪豹4',
  name: '命名着4',
  text: '哇4444真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒',
  type:'images',
  imgShow: 'P-two',
  headerImg: require(`../assets/images/S4.png`),
  logo: '曾小糖gogo4',
  imgSelect: [
    {
      id: 1,
      blackText: '蒙层1111',
      img: require(`../assets/images/Q1.jpg`),
      type:'images'
    },
    {
      id: 2,
      blackText: '蒙层222222',
      img: require(`../assets/images/Q2.jpg`),
      type:'images'
    },
    {
      id: 3,
      blackText: '蒙层33333',
      img: require(`../assets/images/Q3.jpg`),
      video:'https://i.snssdk.com/videofe/xigua/detail?group_id=6804712560730833415',
      type:'video'
    },
    {
      id: 4,
      blackText: '蒙层44444444',
      img: require(`../assets/images/Q4.jpg`),
      video:'https://i.snssdk.com/videofe/xigua/detail?group_id=6804712560730833415',
      type:'images'
    }
  ]
}, {
  id: 5,
  itemName: '雪豹5',
  name: '命名着5',
  text: '哇55555真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒',
  imgShow: 'P-one',
  headerImg: require(`../assets/images/S5.png`),
  logo: '曾小糖gogo5',
  imgSelect: [
    {
      id: 1,
      blackText: '蒙层1111',
      img: require(`../assets/images/Q1.jpg`),
      type:'images'
    },
    {
      id: 2,
      blackText: '蒙层222222',
      img: require(`../assets/images/Q2.jpg`),
      type:'images'
    },
    {
      id: 3,
      blackText: '蒙层33333',
      img: require(`../assets/images/Q3.jpg`),
      video:'https://i.snssdk.com/videofe/xigua/detail?group_id=6804712560730833415',
      type:'video'
    },
    {
      id: 4,
      blackText: '蒙层44444444',
      img: require(`../assets/images/Q4.jpg`),
      type:'images'
    },
    {
      id: 5,
      blackText: '蒙层555555',
      img: require(`../assets/images/Q5.jpg`),
      type:'images'
    }
  ]
}, {
  id: 6,
  itemName: '雪豹6',
  name: '命名着6',
  text: '哇6666666真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒了呢哇真是太棒',
  imgShow: 'P-one',
  headerImg: require(`../assets/images/S5.png`),
  logo: '曾小糖gogo6',
  imgSelect: [
    {
      id: 1,
      blackText: '蒙层1111',
      img: require(`../assets/images/Q1.jpg`),
      type:'images'
    },
    {
      id: 2,
      blackText: '蒙层222222',
      img: require(`../assets/images/Q2.jpg`),
      video:'https://i.snssdk.com/videofe/xigua/detail?group_id=6804712560730833415',
      type:'video'
    },
    {
      id: 3,
      blackText: '蒙层33333',
      img: require(`../assets/images/Q3.jpg`),
      type:'images'
    },
    {
      id: 4,
      blackText: '蒙层44444444',
      img: require(`../assets/images/Q4.jpg`),
      type:'images'
    },
    {
      id: 5,
      blackText: '蒙层555555',
      img: require(`../assets/images/Q5.jpg`),
      video:'https://i.snssdk.com/videofe/xigua/detail?group_id=6804712560730833415',
      type:'video'
    },
    {
      id: 6,
      blackText: '蒙层6666666',
      img: require(`../assets/images/Q1.jpg`),
      type:'images'
    }
  ]
}];
export default {
  tableMap,
  tableCreate,
  tableCartoon,
  tableVidio,
  snowArray
};
